import { render, staticRenderFns } from "./update-edit.vue?vue&type=template&id=0631fc91&scoped=true"
import script from "./update-edit.vue?vue&type=script&lang=js"
export * from "./update-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631fc91",
  null
  
)

export default component.exports